
const fields = [
  {
    type: 'bsx-input',
    inputType: 'text',
    label: '功能標題',
    model: 'title',
    placeholder: '功能標題',
    required: true,
    validator: function () {
      this.validation();
    },
  },
  {
    type: 'bsx-input',
    inputType: 'text',
    label: '功能名稱',
    model: 'name',
    placeholder: '功能名稱',
    required: true,
    disabled: (model) => model.id,
    validator: function () {
      this.validation();
    },
  },
  {
    type: 'bsx-toggle',
    label: '狀態',
    model: 'status',
    required: true,
    textOn: '啟用',
    textOff: '停用',
    valueOn: 'ON',
    valueOff: 'OFF',
  },
];

export default fields;
